/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import {
  LEARNING_GOAL_CARD_SELECT_IMAGE_MAP,
  LEARNING_GOAL_CARD_SELECT_RADIO_NAME,
} from 'bundles/onboarding-2022/constants';
import type { GenericSelectProps } from 'bundles/onboarding-2022/types/GenericSelectProps';
import GoalCard from 'bundles/onboarding-common/components/GoalCard';

type LEARNING_GOAL_CARD_SELECT_OPTIONS = keyof typeof LEARNING_GOAL_CARD_SELECT_IMAGE_MAP;

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    column-gap: var(--cds-spacing-300);
    row-gap: var(--cds-spacing-150);
    padding: var(--cds-spacing-150);

    ${breakpoints.down('sm')} {
      flex-direction: column;
    }
  `,
};

const LearningGoalCardSelect = ({ onChange, questionId, options, value }: GenericSelectProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ [questionId]: event.target.value });
  };

  return (
    <div css={styles.container}>
      {options?.map((option) => (
        <GoalCard
          description={option.text}
          key={option.id}
          imageSrc={
            option.id in LEARNING_GOAL_CARD_SELECT_IMAGE_MAP
              ? LEARNING_GOAL_CARD_SELECT_IMAGE_MAP[option.id as LEARNING_GOAL_CARD_SELECT_OPTIONS]
              : LEARNING_GOAL_CARD_SELECT_IMAGE_MAP.LEARNING_GOAL_LAND_NEW_JOB
          }
          value={option.id}
          radioGroupName={LEARNING_GOAL_CARD_SELECT_RADIO_NAME}
          onChange={handleChange}
          isChecked={value === option.id}
        />
      ))}
    </div>
  );
};

export default LearningGoalCardSelect;
